import { gql } from "@apollo/client";

export const GET_UME_DIETA = gql`
  query getUMEDieta($idEvaluacion: Int!) {
    umeDieta(idEvaluacion: $idEvaluacion) {
      mesAnio
      cantidadDieta
      cantidadSuministro
      cantidadPorcentaje
    }
  }
`;